import ErrorIcon from '@mui/icons-material/Error';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { getBenefitMetadata } from '../../extension/interface/benefit-metadata.extension.interface';

export const getBenefitIcon = (benefit: BenefitDTOBenefitEnum): React.ComponentType<SvgIconProps> => {
  return getBenefitMetadata(benefit)?.Icon ?? ErrorIcon;
};
